import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";

// ================= import images like this =====================
import art1 from "assets/images/arts/1.jpeg"
import art2 from "assets/images/arts/2.jpeg"
import art3 from "assets/images/arts/3.jpeg"
import art4 from "assets/images/arts/4.jpeg"
import art5 from "assets/images/arts/5.jpeg"
import art6 from "assets/images/arts/6.jpeg"
import art7 from "assets/images/arts/7.jpeg"
import art8 from "assets/images/arts/8.jpeg"
import art9 from "assets/images/arts/9.jpeg"
import art10 from "assets/images/arts/10.jpeg"
import art11 from "assets/images/arts/11.jpeg"
import art12 from "assets/images/arts/12.jpeg"

// 
SwiperCore.use([Autoplay, Pagination]);

const NftSlider = () => {
    // =============== After Importing All the Images at the top, Then PUT NFT  images here =================
    const images = [
        art1,
        art2,
        art3,
        art4,
        art5,
        art6,
        art7,
        art8,
        art9,
        art10,
        art11,
        art12,
    ];

    return (
        <section id="nft">
            <div className="sec-heading-wrapper">
                {/* =============== main heading ================== */}
                <h2 data-aos="zoom-in" className="sec-heading">
                    NFT Collection
                </h2>
                {/* =================== body text =================== */}
                <p className="text_center intro" data-aos="fade-up"> 
                The WeStreamers are a collection of 10,420 unique avatars that grants each owner exclusive perks on the WeStream app.
                </p>
                
                    <li style={{padding: "0 12px"}}>
                    3 Year Premium WeStream Membership
                    </li>
                    <li style={{padding: "0 12px"}}>
                    Enhanced livestreaming & commenting privileges <div className="colored"> (Say bye to bots)</div>
                    </li>
                    <li style={{padding: "0 12px"}}>Guaranteed Whitelist to the $STREAM token ICO</li>
                    <li style={{padding: "0 12px"}}>Invitation to the private WeStreamers community</li>
                    <li style={{padding: "0 12px"}}>Access to WeStream App Closed Beta Phase (iPhone/Android)</li>
                
                <p className="text_center intro" data-aos="fade-up">
                And more!
                </p>
            </div>
            {/*================== Slider================= */}
            <Swiper
                autoplay={{ disableOnInteraction: false, delay: 1500 }}
                className="nft-slide-container"
                speed={500}
                pagination={{ clickable: true }}
                spaceBetween={75}
                centerInsufficientSlides
                slidesPerView={3}
                centeredSlides
                loop={true}
                breakpoints={{
                    100: {
                        slidesPerView: 1,
                        spaceBetween: 15
                    },
                    190: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                    1500: {
                        slidesPerView: 4,
                    },
                    1800: {
                        slidesPerView: 5,
                    },
                    2200: {
                        slidesPerView: 5,
                    },
                    2800: {
                        slidesPerView: 6,
                    },
                }}
            >
                {images.map((imgItem, index) => (
                    <SwiperSlide key={index} className="nft-slide">
                        <img className="nft-art-img" src={imgItem} alt="WeStream" />
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    )
}

export default NftSlider
